exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".table>tbody>tr>td[data-v-35ead47c]{padding:0;margin:0 5px;position:relative}.table>tbody>tr>td div.value[data-v-35ead47c]{padding:12px;position:relative}.table>tbody>tr>td div.background[data-v-35ead47c]{position:absolute;margin:0 1%;width:80%;height:100%;visibility:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35ead47c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?data=@import "./src/scss/base";!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/engagement/common/AdditionalDataTableRow.vue
// module id = 768
// module chunks = 1